module.exports = __webpack_public_path__ + "static/media/contabilidade.1e57b407.jpg";